<template>
    <div>
         <b-field class="commonrules-grp" label="The vehicle size is above">
            <b-select class="cstmb-input" v-model="carSize" @input="$emit('carSize',carSize)">
            <option value="M">Mini</option>
            <option value="E">Economy</option>
            <option value="C">Compact</option>
            <option value="Intermediate">Intermediate</option>
            <option value="S">Standard</option>
            <option value="F">Fullsize</option>
            <option value="P">Premium</option>
            <option value="L">Luxury</option>
            <option value="X">Special</option>
           </b-select>
        </b-field>
    </div>
</template>
<script>
export default{
    name : "CarSize",
    props:{carsizeis:null},
    data(){
        return{
             carSize : null
        }
    },
    methods:{
    },
    mounted() {
        this.carSize = this.carsizeis;
    }
}
</script>